/* WP-10 portal-web entry: warm appearance cache before first paint (§14A.9),
 * then router + i18n + appearance revalidation. */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app';
import { applyCachedAppearance, loadAppearance } from './appearance/appearance';
import { applyDisplayPrefs } from './utils/display-prefs';
import { setPortalLocale, currentPortalLocale } from './i18n';
import './theme/journal.css';

applyCachedAppearance();
applyDisplayPrefs();
setPortalLocale(currentPortalLocale());

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

void loadAppearance();

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
